import React from 'react'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'

const TableHead = (props) => {
    const canViewStoreName = checkStoreName()

    return (
        <thead className="ShippingCarrierRuleTableHead TableHead">
        <tr className="RuleHeadTable">
            <th className="brand-name">Brand name</th>
            {canViewStoreName && <th className="store">Store</th>}
            <th className="created-at">Created at</th>
            <th className="updated-at">Updated at</th>
            <th className="Action">Action</th>
        </tr>
        </thead>
    )
}

export default TableHead
